import type { CreatorInfo } from '@ps/types/creator';
import { User } from 'lucide-react';

// ─── Component ──────────────────────────────────────────────────────────

export function AgentInfo({ storeProfile }: { storeProfile: CreatorInfo }) {
  const displayName = storeProfile.name;
  const subtitle = storeProfile.bio;

  return (
    <div className="flex items-center gap-3">
      {storeProfile.avatar ? (
        <img
          src={storeProfile.avatar}
          alt={displayName || 'Agent'}
          className="h-14 w-14 shrink-0 rounded-full object-cover"
        />
      ) : (
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-gray-200 dark:bg-gray-700">
          <User className="h-6 w-6 text-gray-400" />
        </div>
      )}
      <div className="min-w-0">
        <p className="text-base font-medium tracking-[0.2px] text-gray-900 dark:text-white">
          {displayName || 'Agent Name'}
        </p>
        {subtitle && (
          <p className="truncate text-sm font-light tracking-[0.2px] text-gray-400">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}
